import { getTargetOrigin } from './redirectRouteToDomain';

const constructUrl = (path: string, origin?: string, dashboard?: boolean) => (
  `${dashboard
    ? getTargetOrigin(origin) : ''}${path}`
);

export default constructUrl;
